import type { PmsHierarchySelection } from './buildPmsHierarchyTree';

export type PmsHierarchyUiState = {
  selection: PmsHierarchySelection | null;
  expandedKeys: string[];
  treeQuery: string;
  treeWidth?: number;
  /** Required vessel scope for the hierarchy tree */
  vesselId?: number | null;
};

const TREE_WIDTH_MIN = 240;
const TREE_WIDTH_MAX = 560;
const TREE_WIDTH_DEFAULT = 320;

export const PMS_HIERARCHY_STORAGE = 'atlas.pms.hierarchy.ui';
export const PMS_HIERARCHY_PATH = '/pms/hierarchy';

export function clampTreeWidth(width: number): number {
  if (!Number.isFinite(width)) return TREE_WIDTH_DEFAULT;
  return Math.min(TREE_WIDTH_MAX, Math.max(TREE_WIDTH_MIN, Math.round(width)));
}

export function loadPmsHierarchyUiState(): PmsHierarchyUiState | null {
  try {
    const raw = sessionStorage.getItem(PMS_HIERARCHY_STORAGE);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<PmsHierarchyUiState>;
    if (!parsed || typeof parsed !== 'object') return null;
    return {
      selection: parsed.selection ?? null,
      expandedKeys: Array.isArray(parsed.expandedKeys)
        ? parsed.expandedKeys.filter((k) => typeof k === 'string')
        : [],
      treeQuery: typeof parsed.treeQuery === 'string' ? parsed.treeQuery : '',
      treeWidth:
        typeof parsed.treeWidth === 'number' ? clampTreeWidth(parsed.treeWidth) : undefined,
      vesselId:
        typeof parsed.vesselId === 'number' && Number.isFinite(parsed.vesselId)
          ? parsed.vesselId
          : null,
    };
  } catch {
    return null;
  }
}

export function savePmsHierarchyUiState(state: PmsHierarchyUiState): void {
  try {
    sessionStorage.setItem(PMS_HIERARCHY_STORAGE, JSON.stringify(state));
  } catch {
    // ignore
  }
}
